import amplitude from 'tools/amplitude/amplitude';

import {
  LogEventCancelOrder,
  LogEventClickOutOfStockBtn,
  LogEventRemoveItem,
  LogEventSendOutOfStockItems,
  LogSFCancelOrderParams,
  LogSFMainBtnParams,
  LogSFRemoveItemParams,
  LogSFSendStockoutsParams,
} from './substitutionFlow.analytic.model';

export function logAnalyticSFMainBtn(params: LogSFMainBtnParams) {
  const { partnerId, storeId, orderId, orderStatus } = params;
  const data: LogEventClickOutOfStockBtn = {
    PARTNER_ID: partnerId,
    STORE_ID: storeId,
    ORDER_ID: orderId,
    OPENED_BY: orderStatus === 'cooking' ? 'post-take' : 'pre-take',
  };
  amplitude.logEvent('CLICK_OUT_OF_STOCK_BUTTON', data);
}

export function logAnalyticSFSendStockouts(params: LogSFSendStockoutsParams) {
  const {
    partnerId,
    order,
    itemsOutStock,
    flow,
    fromChatBtn,
    suggestions = {
      products: [],
      toppings: [],
    },
    suggestionsAreFromAI = [],
  } = params;
  const isProduct = suggestions.products.length > 0;
  const hasAI = suggestionsAreFromAI.some(isTrue => isTrue);
  let itemsIdSuggested = isProduct
    ? suggestions.products.map(p => p.id)
    : suggestions.toppings.map(t => t.id);
  if (hasAI) {
    itemsIdSuggested = itemsIdSuggested.filter(
      (_, idx) => suggestionsAreFromAI[idx],
    );
  }
  const data: LogEventSendOutOfStockItems = {
    PARTNER_ID: partnerId,
    STORE_ID: order.products[0].storeId,
    ORDER_ID: order.id,
    PRODUCT_IDS: itemsOutStock.products.map(p => p.id),
    CUSTOMIZATION_IDS: itemsOutStock.toppings.map(t => t.detail.id),
    FLOW: flow,
    FLOW_INITIATED_BY: fromChatBtn
      ? 'chat_button'
      : 'select_out_of_stock_button',
    HAS_AI: hasAI,
    ITEMS_ID_SUGGESTED: itemsIdSuggested,
  };
  amplitude.logEvent('SEND_OUT_OF_STOCK_ITEMS', data);
}

export function logAnalyticSFCancelOrder(params: LogSFCancelOrderParams) {
  const { SFState } = params;
  const data: LogEventCancelOrder = {
    PARTNER_ID: SFState.partnerId,
    STORE_ID: SFState.storeId,
    ORDER_ID: SFState.orderId,
  };
  amplitude.logEvent('CANCEL_ORDER_SUBSTITUTION_FLOW', data);
}

export function logAnalyticSFRemoveItem(params: LogSFRemoveItemParams) {
  const { partnerId, storeId, orderId, itemId, type } = params;
  const data: LogEventRemoveItem = {
    PARTNER_ID: partnerId,
    STORE_ID: storeId,
    ORDER_ID: orderId,
    ITEM_ID: itemId,
    TYPE: type,
  };
  amplitude.logEvent('SUBSTITUTION_REMOVE_ITEM', data);
}

export const substitutionFlowAnalytics = {
  logMainBtn: logAnalyticSFMainBtn,
  logSendOutOfStockItems: logAnalyticSFSendStockouts,
  logCancelOrder: logAnalyticSFCancelOrder,
  logRemoveItem: logAnalyticSFRemoveItem,
} as const;
